

function updateRotation(schemeRotation, mainContent) {
  let elHeight = mainContent.clientHeight;
  let elWidth = mainContent.clientWidth;
  let ratio = elHeight / elWidth / 100;
  let respRatio = 7.5
  if( window.innerWidth > 800 ) respRatio = 7
  if( window.innerWidth > 1200 ) respRatio = 6.5
  if( window.innerWidth > 1600 ) respRatio = 5.5
  if( window.innerWidth > 2200 ) respRatio = 4.5
  //if( window.location.href.indexOf('faq') > -1 ) respRatio = respRatio * 1.15
  let newWidth = elWidth + (elWidth * ratio * respRatio);
  schemeRotation.style.setProperty('--bgMaskWidth', newWidth + 'px')

  let bgWidth = newWidth;
  let bgHeight = elHeight //schemeRotation.clientHeight;
  let bgLeft = schemeRotation.offsetLeft - (bgWidth / 2);
  let bgTop = schemeRotation.offsetTop - (bgHeight / 2);

  let contentWrap = mainContent.querySelector('.inner-content')
  let contentTop = contentWrap.getBoundingClientRect().top

  let corner = {
    top_left: schemeRotation.querySelector('#mask_tl'),
    top_right: schemeRotation.querySelector('#mask_tr'),
    bottom_right: schemeRotation.querySelector('#mask_br'),
    bottom_left: schemeRotation.querySelector('#mask_bl'),
  }

  let cornerPos = {
    top_left: {
      x: corner.top_left.getBoundingClientRect().left,
      y: corner.top_left.getBoundingClientRect().top - contentTop
    },
    top_right: {
      x: corner.top_right.getBoundingClientRect().left,
      y: corner.top_right.getBoundingClientRect().top - contentTop
    },
    bottom_right: {
      x: corner.bottom_right.getBoundingClientRect().left,
      y: corner.bottom_right.getBoundingClientRect().top - contentTop
    },
    bottom_left: {
      x: corner.bottom_left.getBoundingClientRect().left,
      y: corner.bottom_left.getBoundingClientRect().top - contentTop
    }
  }
  contentWrap.style.setProperty(
        "clip-path",
        `polygon(${cornerPos.top_left.x}px ${cornerPos.top_left.y}px, ${cornerPos.top_right.x}px ${cornerPos.top_right.y}px, ${cornerPos.bottom_right.x}px ${cornerPos.bottom_right.y}px, ${cornerPos.bottom_left.x}px ${cornerPos.bottom_left.y}px)`
      );
}
function checkSchemeRotation(schemeRotation, mainContent, type) {
  //console.log('Check scheme', type)
  if (type == 'iframe') {
    mainContent.querySelector('iframe').style.width = 0 + 'px';
    setTimeout(function(){
      mainContent.querySelector('iframe').style.width = '';
      setTimeout(function(){
        updateRotation(schemeRotation, mainContent)
      }, 10)
    }, 10)
  } else {
    updateRotation(schemeRotation, mainContent)
  }
}

let schemeRotation = document.querySelector('#bgmask')
let mainContent = document.querySelector('.main-content')
if( mainContent && schemeRotation ) {
  checkSchemeRotation(schemeRotation, mainContent, 'First')
  window.addEventListener('resize', function(){
    checkSchemeRotation(schemeRotation, mainContent, 'Resize')
  });
  window.addEventListener('load', function(){
    checkSchemeRotation(schemeRotation, mainContent, 'Load')
  });
  mainContent.addEventListener('resize', function(){
    checkSchemeRotation(schemeRotation, mainContent, 'Content resize')
  });
  mainContent.addEventListener('click', function(){
    checkSchemeRotation(schemeRotation, mainContent, 'Content resize click')
    let clickInterval = setInterval(function(){
      checkSchemeRotation(schemeRotation, mainContent, 'Content resize click')
    }, 30)
    setTimeout(function(){
      clearInterval(clickInterval)
    }, 400);
  })
  mainContent.querySelectorAll('iframe').forEach(function(iframe){
    iframe.addEventListener('load', function(){
      setTimeout(function(){
        checkSchemeRotation(schemeRotation, mainContent, 'iframe')
      }, 100);
    })
  })
  if( mainContent.querySelector('.insta-feed-section') || mainContent.querySelector('.pxFormGenerator') ) {
    mainContent.addEventListener('DOMNodeInserted', function(e){
      if( e.target.tagName == 'IFRAME' ) {
        e.target.addEventListener('load', function(){
          checkSchemeRotation(schemeRotation, mainContent, 'iframe')
          setTimeout(function(){
            checkSchemeRotation(schemeRotation, mainContent, 'iframe')
          }, 1000);
        })
        e.target.addEventListener('click', function(){
          checkSchemeRotation(schemeRotation, mainContent, 'iframe')
        })
      } else {
        checkSchemeRotation(schemeRotation, mainContent, 'DOMNodeInserted')
      }
    });
  }
}
/*setInterval(function () {
  var isSelected = document
    .querySelector(".enhanced-web-home-banner")
    .classList.contains("is-selected");
  if (isSelected) {
    // console.log(isSelected);
    $(".mobile_image_bottom").show();
  } else {
    //console.log(isSelected);
    $(".mobile_image_bottom").hide();
    $(".slideshow-container").hide();
    $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").hide();
    $(".enhanced-web-block3").next().find("#toggle_button").hide();
  }
}, 1000);*/
/*setInterval(function () {
  var isSelected = document
    .querySelector(".hp-banner")
    .classList.contains("is-selected");
  if (isSelected) {
    // console.log(isSelected);
    $(".mobile_image_bottom").show();
      // $(".slideshow-container").hide();
    $(".enhanced-web-block1,.enhanced-web-block2,.enhanced-web-block3").hide();
    $(".enhanced-web-block3").next().find("#toggle_button").hide();
  } 
},1000);

 */
